import { Box, Tab, Tabs, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { useSearchParams } from 'react-router-dom';
import { useMemo, useState, useEffect } from 'react';
import { useScopeCheck } from '../../../../reusable-components/scopes';
import ManualGLTable from './ManualGLTable';
import ManualVendorTable from './ManualVendorTable';
import { useDispatch } from '../../../../redux/store';
import { getVendors, getVendorBookingTypes } from '../../../../redux/slices/invoicing';
import LoadingAnimation from '../../../../reusable-components/loader/LoadingAnimation';

export default function InvoicingVendors() {
  const [tab, setTab] = useState(0);
  const [vendorsDataLoaded, setVendorsDataLoaded] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();

  const handleTabChange = (e, newValue) => {
    setTab(newValue);
    setSearchParams({ tab: newValue });
  };

  useEffect(() => {
    const tabParam = parseInt(searchParams.get('tab'), 10);
    if (!Number.isNaN(tabParam) && tabParam !== tab) {
      setTab(tabParam);
    }
  }, [searchParams]);

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(getVendors());
      setVendorsDataLoaded(true);
      dispatch(getVendorBookingTypes());
    };

    fetchData();
  }, []);

  const tabs = [
    {
      tabLabel: "Invoice Vendors",
      tabComponent: (<ManualVendorTable />),
      permissions: useScopeCheck(['Admin', 'View-Invoice-Vendors', 'Edit-Invoice-Vendors'], true)
    },
    {
      tabLabel: "Invoice GLs",
      tabComponent: (<ManualGLTable />),
      permissions: useScopeCheck(['Admin', 'View-Invoice-GLs', 'Edit-Invoice-GLs'], true)
    }

  ];

  const filteredChoices = tabs.filter(c => c.permissions === true);

  const renderTabContent = useMemo(() => filteredChoices[tab]?.tabComponent, [filteredChoices, tab]);

  return (
    <>
      <Tabs
        value={tab}
        onChange={handleTabChange}
        indicatorColor="transparent"
        sx={{ borderRadius: '4px 4px 0px 0px' }}>
        {filteredChoices.map((c, index) => <CustomTab key={index} label={<Box>
          <Typography variant="subtitle1" color="success.contrastText" component="span">
            {c.tabLabel}
          </Typography>
        </Box>
        } />)}

      </Tabs>
      <Box sx={{ pt: 1 }}>
        {!vendorsDataLoaded ? (
          <Box
            sx={{
              zIndex: 999999999999999,
              height: 'calc(100vh - 280px)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <LoadingAnimation />
          </Box>
        ) : (
          renderTabContent
        )}
      </Box>
    </>
  );
}

const CustomTab = styled((props) => <Tab {...props} />)(({ selected }) => ({
  minWidth: '160px',
  minHeight: '43px',
  height: '43px',
  maxHeight: '43px',
  borderBottom: 'none',
  marginTop: '5px',
  marginLeft: '4px',
  marginRight: '4px',
  borderLeft: 'none',
  borderRight: 'none',
  borderTop: 'none',
  color: '#444',
  borderRadius: '5px 5px 0px 0px',
  backgroundColor: selected ? '#fff' : '#f4f6f8',
  boxShadow: selected ? '0px 2px 4px 1px rgba(0, 0, 0, 0.2)' : '0px 1px 2px rgba(0, 0, 0, 0.1)',
  transition: 'background-color 0.2s ease-in-out, color 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: '#fff',
    color: '#000',
    borderBottom: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    borderTop: 'none',
    boxShadow: '0px 2px 4px 1px rgba(0, 0, 0, 0.2)',
  },
  '& .MuiTab-wrapper': {
    flexDirection: 'column',
    alignItems: 'center',
  },
}));
